var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        ["billing-information-popup"]: true,
        ["hide"]: _vm.popupOpen !== "billingInformation",
      },
    },
    [
      _c("div", { ref: "billingInformationPopup", staticClass: "popup" }, [
        _c("div", { staticClass: "title-section" }, [
          _c("h2", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "dash.settings.billing.card.billing_information.billing_information.title"
                )
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("dash.settings.billing.edit_billing.subtitle"))
            ),
          ]),
        ]),
        _c("div", { staticClass: "content-form" }, [
          _c("div", { staticClass: "container-input business" }, [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.$t("dash.settings.billing.edit_billing.business.label")
                )
              ),
            ]),
            _c("div", { staticClass: "input" }, [
              _c("i", { staticClass: "fa-solid fa-briefcase" }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formInfoAccount.company,
                    expression: "formInfoAccount.company",
                  },
                ],
                attrs: {
                  placeholder: _vm.$t(
                    "dash.settings.billing.edit_billing.business.placeholder"
                  ),
                },
                domProps: { value: _vm.formInfoAccount.company },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.formInfoAccount,
                      "company",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "container-input adress" }, [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.$t("dash.settings.billing.edit_billing.location.label")
                )
              ),
            ]),
            _c("div", { staticClass: "input" }, [
              _c("i", { staticClass: "fa-solid fa-house-user" }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formInfoAccount.address,
                    expression: "formInfoAccount.address",
                  },
                ],
                attrs: {
                  placeholder: _vm.$t(
                    "dash.settings.billing.edit_billing.location.placeholder"
                  ),
                },
                domProps: { value: _vm.formInfoAccount.address },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.formInfoAccount,
                      "address",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "container-input adress" }, [
            _c("label", [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("dash.settings.billing.edit_billing.country.label")
                  )
                ),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("dash.settings.billing.edit_billing.zipcode.label")
                  )
                ),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("dash.settings.billing.edit_billing.city.label")
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "inputs" }, [
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-solid fa-earth-americas" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formInfoAccount.country,
                      expression: "formInfoAccount.country",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.settings.billing.edit_billing.country.placeholder"
                    ),
                  },
                  domProps: { value: _vm.formInfoAccount.country },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.formInfoAccount,
                        "country",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-solid fa-location-dot" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formInfoAccount.zipcode,
                      expression: "formInfoAccount.zipcode",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.settings.billing.edit_billing.zipcode.placeholder"
                    ),
                  },
                  domProps: { value: _vm.formInfoAccount.zipcode },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.formInfoAccount,
                        "zipcode",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-solid fa-city" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formInfoAccount.city,
                      expression: "formInfoAccount.city",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.settings.billing.edit_billing.city.placeholder"
                    ),
                  },
                  domProps: { value: _vm.formInfoAccount.city },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formInfoAccount, "city", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "container-input tva" }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("dash.settings.billing.edit_billing.tva.label"))
              ),
            ]),
            _c("div", { staticClass: "input" }, [
              _c("i", { staticClass: "fa-solid fa-tag" }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formInfoAccount.vat_number,
                    expression: "formInfoAccount.vat_number",
                  },
                ],
                attrs: {
                  placeholder: _vm.$t(
                    "dash.settings.billing.edit_billing.tva.placeholder"
                  ),
                },
                domProps: { value: _vm.formInfoAccount.vat_number },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.formInfoAccount,
                      "vat_number",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "btns" }, [
          _vm.formInfoAccountIsModified()
            ? _c(
                "div",
                {
                  staticClass: "btn-outline-primary",
                  on: { click: _vm.cancel },
                },
                [_vm._v(_vm._s(_vm.$t("dash.button.cancel")))]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "btn-primary icon-r", on: { click: _vm.save } },
            [_vm._v(_vm._s(_vm.$t("dash.button.save")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }